<div>
    <div class="date-picker row">
        <span>From</span>
        <div class="date-picker-col">
            <input type="date"
                   [ngModel]="formatDateForInput(manualDateSelectInfo.from)"
                   (ngModelChange)="onDateSelect('from', $event)"
                   class="custom-text-input"
                   id="range-selector-from"
                   placeholder="DD/MM/YYYY">
        </div>
        <span>To</span>
        <div class="date-picker-col">
            <input type="date"
                   [ngModel]="formatDateForInput(manualDateSelectInfo.to)"
                   (ngModelChange)="onDateSelect('to', $event)"
                   class="custom-text-input"
                   id="range-selector-to"
                   placeholder="DD/MM/YYYY">
        </div>
    </div>
    <div>
        <div class='chart-div' [chart]="chart"></div>
    </div>
</div>
